var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.15,126.6l5.93,14.31,14.58-8.33,14.39,8.33,7.56-14.31h19.33l-2.53-18.13,16-6.41-10-13.38,9.33-16.44-15.33-8V47.57H127.74l-7.69-15.73-14.39,9.73L90.41,31.84l-8,16.4-17.33-2V65L50.25,72.13l9.31,15.28-9.31,14.65,16,6.41V126.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.68,137.66,94.49,190.14,83.25,175.7a3.85,3.85,0,0,0-4-1.36l-21,5.59L77.53,126.6m60.88,0,18.4,52.8-21-5.08a3.84,3.84,0,0,0-3.93,1.37l-11,14.06-11.65-48.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/AWARDS.ceb2a62f85a3c6be959ee8cba1c2aa8b.svg";
export { ForwardRef as ReactComponent };